<script>
import { mergeData } from 'vue-functional-data-merge';
const VEntry = () => import('./Entry');

export default {
  name: 'DescriptionListEntryBadge',

  functional: true,

  props: {
    badge: {
      type: [Number, String],
      required: false,
      default: null,
    },
  },

  render(h, { props, data, children, parent }) {
    const componentData = {
      scopedSlots: {},
    };

    componentData.scopedSlots.default = () => {
      let badge;
      if (data.scopedSlots?.badge) {
        badge = data.scopedSlots.badge();
      } else {
        let staticClass = 'badge';
        if (data.staticClass) staticClass += ` ${data.staticClass}`;
        badge = h('div', { class: data.class, staticClass, domProps: { innerHTML: parent.$to(props.badge) } });
      }
      return badge;
    };

    return h(VEntry, mergeData(data, componentData), children);
  },
};
</script>
